import { Toaster } from "react-hot-toast";
import toast from "react-hot-toast";
import { useEffect } from "react";
import { getPlatform, isNativeApp } from "@/platform";

export const ToastContainer = () => {
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);

  const isAndroid = getPlatform() === "android";

  return (
    <Toaster
      containerStyle={{
        ...(isAndroid && {
          top: 24,
          marginTop: 24,
        }),
        ...(isNativeApp() && {
          top: "calc(env(safe-area-inset-top) + 12px)",
        }),
      }}
      toastOptions={{
        style: { fontFamily: "sans-serif", color: "#1f243c" },
      }}
    />
  );
};

export const useToast = () => {
  return {
    toast,
    ToastContainer,
  };
};
